import {i18n2} from 'features/i18n/i18n';
import * as yup from 'yup';

export const ContentSchema = () =>
  yup.object({
    iD_Content: yup.number().label(i18n2._('ID Contenido')),
    type: yup.number().label(i18n2._('Tipo')),
    title: yup.string().label(i18n2._('Título')),
    description: yup.string().label(i18n2._('Descripción')),
    revision: yup.number().label(i18n2._('Revision')),
    reason: yup
      .string()
      .max(255)
      .required(i18n2._('Este campo es obligatorio'))
      .label(i18n2._('Motivo')),
    updateDate: yup.date().label(i18n2._('Fecha de actualizacion')),
    updatedBy: yup.string().label(i18n2._('Actualizado por')),
    deleted: yup.boolean().label(i18n2._('Eliminado')),
  });
